import { useTranslation } from 'react-i18next';

import { useHistory } from '@treams/treams-routes';
import { Modal, Separator } from '@treams/treams-ui';

import Chooser from 'packages/kakapo-ui-kit/components/forms/controls/Chooser';
import useFeature from 'packages/kakapo-ui-application/hooks/useFeature';
import { ComposeIcon, DocumentIcon, SuitcaseIcon, TargetIcon } from '@treams/treams-icons';
import { Box } from 'reflexbox';

export default function FeedbackRequestModalMethod(props: {
	returnURL: string;
	onChange: (method: 'custom' | 'template') => void;
}) {
	const history = useHistory();

	const { t } = useTranslation();

	const hasGoals = useFeature('2021.goals');
	const hasFeedbackGoals = useFeature('2021.feedback.goals');
	const hasFeedbackCompetencies = useFeature('2021.feedback.competencies');

	return (
		<Modal>
			<Modal.Header title={t('common.feedback.create')} />

			<Modal.Contents>
				<Chooser
					options={[
						{
							id: 'template',
							icon: <DocumentIcon />,
							name: t('feedback.create.method.template'),
						},
						...(hasGoals && hasFeedbackGoals
							? [
									{
										id: 'goals',
										icon: <TargetIcon />,
										name: t('feedback.create.method.goals'),
									},
							  ]
							: []),
						...(hasFeedbackCompetencies
							? [
									{
										id: 'competencies',
										icon: <SuitcaseIcon />,
										name: t('feedback.create.method.competencies'),
									},
							  ]
							: []),
					]}
					onChange={({ id }) => props.onChange(id as any)}
				/>

				<Separator my={3} />

				<Box mb={-2}>
					<Chooser
						options={[
							{
								id: 'custom',
								icon: <ComposeIcon />,
								name: t('feedback.create.method.plain'),
							},
						]}
						onChange={({ id }) => props.onChange(id as any)}
					/>
				</Box>
			</Modal.Contents>

			<Modal.FormFooter onCancel={() => history.push(props.returnURL)} disabled />
		</Modal>
	);
}
